/**
 * Global theme helpers shared across independently-loaded section/block
 * scripts: a small cart fetch API built on a document-level event bus so
 * components (header badge, cart drawer, product forms, quick add) never
 * need to reference each other directly.
 */
window.Theme = window.Theme || {};

Theme.debounce = function debounce(fn, wait) {
  let timeout;
  return function debounced(...args) {
    window.clearTimeout(timeout);
    timeout = window.setTimeout(() => fn.apply(this, args), wait);
  };
};

Theme.cart = (function () {
  const sectionIds = ['header', 'cart-drawer'];

  function renderSections(sections) {
    if (!sections) return;

    if (sections.header) {
      const doc = new DOMParser().parseFromString(sections.header, 'text/html');
      const newBadge = doc.querySelector('[data-cart-count]');
      const liveBadge = document.querySelector('[data-cart-count]');
      if (newBadge && liveBadge) {
        liveBadge.textContent = newBadge.textContent;
        liveBadge.classList.toggle('is-hidden', newBadge.classList.contains('is-hidden'));
      }
    }

    if (sections['cart-drawer']) {
      const doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      const newContent = doc.querySelector('[data-cart-drawer-content]');
      const liveContent = document.querySelector('[data-cart-drawer-content]');
      if (newContent && liveContent) {
        liveContent.innerHTML = newContent.innerHTML;
      }
    }
  }

  async function request(url, options) {
    const response = await fetch(url, options);
    const data = await response.json();

    if (!response.ok) {
      document.dispatchEvent(new CustomEvent('cart:error', { detail: data }));
      throw data;
    }

    renderSections(data.sections);
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
    return data;
  }

  return {
    sectionIds,
    renderSections,
    add(formData) {
      formData.append('sections', sectionIds.join(','));
      return request('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
      });
    },
    change(line, quantity) {
      return request('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity, sections: sectionIds.join(',') }),
      });
    },
  };
})();
